var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprite.svg#icon-profile';
                    var viewUrl = 'sprite.svg#view-icon-profile';

                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 12 15',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };